import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import { toggleBlockUserConfirmBox } from 'store/actions/confirmBox'
import { endpoints } from 'store/api/yay/user'

import Menu from 'components/Menu'
import { useReportModal } from 'components/Modal/ReportModal/ReportModal'

const UserMenu = ({
  hideArrow = false,
  icon,
}: {
  icon: any
  hideArrow?: boolean
}) => {
  const dispatch = useDispatch()
  const params = useParams()
  const { t } = useTranslation()
  const reportModal = useReportModal()

  const userRes = endpoints?.getUser?.useQueryState?.({
    userId: params?.userId,
  })

  const user = userRes?.data

  const menu = [
    {
      title: t('common.share'),
      onClick: () => {
        window.open(
          `https://twitter.com/intent/tweet?text=${user?.nickname}&url=${window.location.origin}/user/${user?.id}`,
          '_newtab'
        )
      },
    },
    {
      title: t('common.block'),
      onClick: () => dispatch(toggleBlockUserConfirmBox({ user })),
    },
    {
      title: t('common.report'),
      onClick: () =>
        reportModal.open({
          userId: user?.id?.toString?.(),
        }),
    },
  ]

  return (
    <Menu
      options={menu}
      handlerClassName="Button"
      icon={icon}
      hideArrow={hideArrow}
    />
  )
}

export default UserMenu
